import { BREAKPOINTS } from "constants/breakpoints";

export const EDeviceSize = {
    DesktopLarge: `(max-width: ${BREAKPOINTS.desktopLarge})`,
    Desktop: `(max-width: ${BREAKPOINTS.desktop})`,
    Tablet: `(max-width: ${BREAKPOINTS.tablet})`,
    MiniTablet: `(max-width: ${BREAKPOINTS.miniTablet})`,
    Middle: `(max-width: ${BREAKPOINTS.middle})`,
    SmallTablet: `(max-width: ${BREAKPOINTS.smallTablet})`,
    Mobile: `(max-width: ${BREAKPOINTS.mobile})`,

    // Custom / probably redundant
    MobileRedundant: "(min-width: 575px)",
} as const;
